import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=25f87dd2&"
import script from "./Landingpage.vue?vue&type=script&lang=ts&"
export * from "./Landingpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports